// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "recommendations-" + chunkId + ".js?v=" + "d0bba19fc6d463e6deda" + "";
};